// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content-33a_g","flexContainer":"flexContainer-2-ao0","linkBox":"linkBox-1HtLC","tab":"tab-3AVw4","label":"label-3j1J1"};